import styled from "styled-components";

export default styled.span`
  white-space: nowrap;
  color: white;
  background: red;
  font-size: 1.4rem;
  font-weight: 800;
  border-radius: 6px;
  padding: 3px;
  margin: 3px;
  margin-left: 3px;
  position: absolute;
  top: 8px;
  z-index: 1000;
  pointer-events: none;
`;
